import OneSignal from 'react-onesignal';
import { jouerSonNotification } from '../utils/sons';

let initialized = false;

export async function initOneSignal() {
  if (initialized) return;
  initialized = true;
  await OneSignal.init({
    appId: 'bb9df70b-d021-4a09-9118-cce5941e8fcc',
    allowLocalhostAsSecureOrigin: true,
    notifyButton: { enable: false },
    // Réutilise le service worker CRA déjà enregistré (voir src/service-worker.js)
    // au lieu d'en enregistrer un second au même scope.
    serviceWorkerPath: 'service-worker.js',
    serviceWorkerParam: { scope: '/' },
  });

  // Joue un son distinct selon le type de notif quand le gérant a l'app
  // ouverte au moment où le push arrive (app fermée = son système du navigateur).
  OneSignal.Notifications.addEventListener('foregroundWillDisplay', (event) => {
    const type = event.notification?.additionalData?.type;
    jouerSonNotification(type);
  });
}

export async function setOneSignalUser(userId) {
  await OneSignal.login(userId);
}

export async function requestPermission() {
  await OneSignal.Notifications.requestPermission();
}

export async function getPlayerId() {
  return await OneSignal.User.PushSubscription.id;
}
